module.exports = __webpack_public_path__ + "img/completed_pickup.969b13ec.svg";